import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { EmotionalConnection } from '../components/EmotionalConnection';
import { AvatarPains } from '../components/AvatarPains';
import { SolutionBenefits } from '../components/SolutionBenefits';
import { ProductOffer } from '../components/ProductOffer';
import { Bonuses } from '../components/Bonuses';
import { BreedGallery } from '../components/BreedGallery';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
export function LandingPage() {
  return <div className="min-h-screen font-body text-deep-brown selection:bg-soft-rose selection:text-white" data-id="element-341">
      <main data-id="element-342">
        <HeroSection data-id="element-343" />
        <EmotionalConnection data-id="element-344" />
        <AvatarPains data-id="element-345" />
        <SolutionBenefits data-id="element-346" />
        <BreedGallery data-id="element-347" />
        <ProductOffer data-id="element-348" />
        <Bonuses data-id="element-349" />
        <Testimonials data-id="element-350" />
        <FAQ data-id="element-351" />
      </main>
      <Footer data-id="element-352" />
      <FloatingCTA data-id="element-353" />
    </div>;
}